<div class="serial-wrapper">
  <div class="serial-container">
    <div class="serial-number-control">
      <app-custom-input-text
        label="captive.form.my-device.serialNumber"
        placeholder="captive.form.my-device.serialNumber"
        key="serial"
        type="text"
        [control]="serialControl"
        [isRequired]="false" />

      <div class="info-wrapper">
        <div class="info-icon" (click)="onOpenSerialInfo()"></div>
      </div>

      <div class="info-wrapper" title="{{ 'captive.form.my-device.unlinkDevice' | translate }}">
        <div class="unlink-icon" (click)="onUnlinkSerial(user)"></div>
      </div>
    </div>

    <div class="shared-device-section">
      <app-shared-device-control
        class="shared-device-control"
        [hintText]="'captive.form.my-device.shared-device.hint.sharing-registered-device'"
        [submitted]="isSubmittedPassphraseControl"
        [errorsList]="errorFeedbackList.passphrase"
        [passphraseControl]="passphraseControl"
        (useSharedDeviceChanged)="onUseSharedDevice($event)"
        (openSharedDeviceInfo)="onOpenSharedDeviceInfo()"
        (changedPassphraseValue)="onChangedPassphrase($event)" />

      <div *ngIf="hasDevicePassphrase" class="passphrase-view custom-input-wrapper form-label">
        {{ 'captive.form.my-device.passphrase' | translate }}: {{ userDevice?.passphrase }}
      </div>
    </div>

    <app-problem-with-serial-error *ngIf="isShowProblemFormFor()" />
  </div>
  <!-- NOTE: Do not remove, helps update form status -->
  <ng-template *ngIf="serialControl.statusChanges | async" />
</div>
